<template>
    <div class="container">
        <div class="imgBox">
            <img class="loading" :src='require("@/assets/images/pay/loading.gif")' />
            <img class="error" :src='require("@/assets/images/pay/error.png")' />
        </div>
        <p class="msg">二维码支付中</p>
        <div class="tip">
            <p class="title red">温馨提示：</p>
            <div class="row"><span class="index">1.</span>
                <div>您正在芯河云谷平台进行交易，如非本人操作，请勿支付</div>
            </div>
            <div class="row"><span class="index">2.</span>
                <div>任何人以“兼职、刷单、返现、退款、保证金”等名义让您支付、引导您操作、请您警惕，谨防诈骗</div>
            </div>
            <div class="row"><span class="index">3.</span>
                <div>如您是正常交易且多次扫码仍提示二维码过期，请您先自行检查您的手机网络，确保网络畅通，或联系本站客服</div>
            </div>
        </div>
    </div>
</template>

<script>
 function getQueryString (name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return undefined;
  }
  function handleError(text){
    document.getElementsByClassName("loading")[0].style.display='none'
    document.getElementsByClassName("error")[0].style.display='inline'
    document.getElementsByClassName("msg")[0].innerText=text
  }
  const ready=()=>{
    let payEnv;
    const ua=window.navigator.userAgent.toLowerCase()
    let code=getQueryString("code")
    if(/alipayclient/.test(ua)){
      payEnv='ALIPAY'
      document.addEventListener('resume', function(event) {
        AlipayJSBridge.call('popWindow');
      });
    }else if (/micromessenger/.test(ua)){
      payEnv='WECHAT'
      if(!code||code===''){
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx984c76c796596c83&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_base&state=auth#wechat_redirect`
        return
      }
    }else{
      handleError("请在支付宝或微信中打开哦~")
      return;
    }
    const no=getQueryString("no")
    const t=getQueryString("t")
    let url='https://api.3sd.cn/pay?'+"no="+no+"&t="+t
    if(code&&code!==""){
      url+="&code="+code
    }
    const http = new XMLHttpRequest();
    http.open('GET',url);
    http.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
    http.timeout = 5000;
    http.onload = () => {
      if (http.status === 200) {
        const resp = JSON.parse(http.responseText);
        const {code,msg}=resp;
        if(code!==0){
          handleError(msg)
          return
        }
        const {data,method}=resp.data;
        if(method==='WECHAT'&&payEnv!=='WECHAT'){
          handleError("请在微信中打开哦~")
          return;
        }
        if((method==='ALIPAY'||method==='ALIPAY_TRANSFER')&&payEnv!=='ALIPAY'){
          handleError("请在支付宝中打开哦~")
          return;
        }
        if(method==="ALIPAY"){
          AlipayJSBridge.call('pushWindow', {
            url: 'alipays://platformapi/startapp?appId=10000007&qrcode='+data,
          });
        }else if(method==="ALIPAY_TRANSFER"){
          AlipayJSBridge.call('pushWindow', {
            url: 'alipays://platformapi/startapp?appId=10000007&qrcode='+encodeURIComponent(data),
          });
        }else if(method==="WECHAT"){
          window.WeixinJSBridge.call('closeWindow');
          window.WeixinJSBridge.invoke('getBrandWCPayRequest',data,
            (res) => {
            });
        }
      }else{
        handleError("服务器错误，请重试")
      }
    };
    http.ontimeout = (e) => {
      handleError("请求超时，请检查网络重试")
    };
    http.send();
  }
//   ready()
export default {

}
</script>

<style lang="less" scoped>
.container {
    width: 100%;

    .imgBox {
        text-align: center;

        .loading {
            width: 64px;
            height: 64px;
            margin-top: 46px;
            margin-bottom: 24px;
        }

        .error {
            width: 128px;
            height: 128px;
            margin-top: 6px;
            display: inline;
        }
    }

}

.msg {
    padding: 0 30px;
    line-height: 22px;
    font-size: 20px;
    color: #333;
    font-weight: bold;
}

.tip {
    margin: 12px 32px;
    display: inline-block;
    text-align: left;

    .row {
        color: #666;
        font-size: 15px;
        margin: 6px 0;
        display: flex;
    }
}
</style>